/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum TransactionType {
    A2A = 'A2A',
    A2C = 'A2C',
    AFL = 'AFL',
    C2A = 'C2A',
    C2C = 'C2C',
    CBC = 'CBC',
    CORPA2A = 'CORPA2A',
    CORPA2C = 'CORPA2C',
    CORPC2A = 'CORPC2A',
    CORPC2C = 'CORPC2C',
    CW = 'CW',
    P2P = 'P2P',
    P2PO = 'P2PO',
    PAYPOS = 'PAYPOS',
    PAYQR = 'PAYQR',
    TOPCW = 'TOPCW',
    TOPEWP = 'TOPEWP',
    TOPEWT = 'TOPEWT',
    TOPOTH = 'TOPOTH',
    TOPPB = 'TOPPB',
    TOPUPCACD = 'TOPUPCACD',
    TOPUPCATM = 'TOPUPCATM',
    TOPUPCCD = 'TOPUPCCD',
    WATM = 'WATM'
}

